export default function ActividadProfesional() {
  return (
    <section className="bio-content container my-3">
      <div className="consultoras card border-0 shadow-sm p-4 rounded-4">
        <h3 className="fw-bold mb-4 text-center">Consultoría económica</h3>
        
        
        <div className="row g-4 justify-content-center">
          
          {/* Consultora 1 */}
          <div className="col-12 col-md-6">
            <div className="card border-0 bg-light p-4 rounded-4 text-center h-100 d-flex flex-column align-items-center">
              <img 
                src="/ecogo_logo.png" 
                alt="Eco Go" 
                style={{ height: "50px", objectFit: "contain", marginBottom: "15px" }} 
              />
              <h5 className="fw-bold">Eco Go Consultores</h5>
              <p className="text-muted px-2">
                Análisis macroeconómico estratégico y asesoramiento financiero para proyectos de inversión y toma de decisiones. 
              </p>
              <a 
                href="https://ecogo.com.ar/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="btn btn-sm btn-outline-secondary"
              >
                Sitio web
              </a>
            </div>
          </div>

          {/* Consultora 2 */}
          <div className="col-12 col-md-6">
            <div className="card border-0 bg-light p-4 rounded-4 text-center h-100 d-flex flex-column align-items-center">
              <img 
                src="/Logo_IES_2011.jpg" 
                alt="IES" 
                style={{ height: "50px", objectFit: "contain", marginBottom: "15px" }} 
              />
              <h5 className="fw-bold">IES Consultores</h5>
              <p className="text-muted px-2">
                Especialistas en investigaciones económicas sectoriales y monitoreo de mercados regionales.
              </p>
              <a 
                href="https://iesonline.ar/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="btn btn-sm btn-outline-secondary"
              >
                Sitio web
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}